import React, {useContext} from "react";
import './Projects.css';
import SectionHeading from "../SectionHeading";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import GitHubIcon from '@mui/icons-material/GitHub';
import {PortfolioContext} from '../../App';


const Project = ({title, external, tech, github, image, description, cta}) => {
    return (
        <div className="style-project">
            <div className="project-content">
                <div>
                    <p className="project-overline">Featured Project</p>
                    <h3 className="project-title">
                        <a href={external}>{title}</a>
                    </h3>

                        <div className="project-description">
                            <p>{description}</p>
                        </div>

                        {tech.length && (
                        <ul className="project-tech-list">
                            {tech.map((tech, i) => (
                            <li key={i}>{tech}</li>
                            ))}
                        </ul>
                        )}

                        <div className="project-links">
                        {cta && (
                            <a href={cta} aria-label="Course Link" className="cta">
                            Learn More
                            </a>
                        )}
                        {github && (
                            <a href={github} aria-label="GitHub Link">
                            <GitHubIcon />
                            </a>
                        )}
                        {external && !cta && (
                            <a href={external} aria-label="External Link" className="external">
                            <OpenInNewIcon />
                            </a>
                        )}
                        </div>
                    </div>
                    </div>

            <div className="project-image">
                    <div>
                        <img src={image} alt={title} className="img" />
                    </div>
            </div>

        </div>

    )
}


const Projects = () => {

    const portfolio = useContext(PortfolioContext);
    const projects = portfolio['projects'] || "";
    return (
        <section className="project-section" id="projects">
            <SectionHeading number={'03.'} heading={'Some Things I’ve Built'} />
            <div className="projects-grid">
                {projects && projects.map((project, i) => (
                    <Project  title={project.name} description={project.description} tech={project.tags} image={require(`../../images/projects/${project.image}`)}  />
                ))}
            </div>
        </section>
    )
}

export default Projects